import { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';

import { TRANSLITIONS_KEYS } from '../constants.buzz.js';

export const useSetTranslations = () => {
    const t = useTranslations();

    return useCallback((type) => {
        const tKeys = TRANSLITIONS_KEYS[type] || {};
        const translations = {};

        for (const tKey in tKeys) {
            translations[tKey] = t(tKeys[tKey]);
        }

        if (type === 'chat') {
            window.Communication?.API?.chat?.addTranslations?.(translations);
        } else {
            window.Communication?.API?.inbox?.addTranslations?.(translations);
        }
    }, [t]);
};
